import { fetchAccessToken, connectMessagingClient } from './twiliochat'
import TwilioEventsAdaptor from '../transformers/TwilioEventsAdaptor'
var lodash = require("lodash/function");
const Chat = require('twilio-chat');

export default class TwilioChatService {

    constructor() {
        this.client = undefined
    }

    // returns the initiated client
    async init(hooks) {
        this.token = await fetchAccessToken()
        this.client = await connectMessagingClient(this.token)
        this.mapTwilioEventHandlers(new TwilioEventsAdaptor(hooks))
        return this.client
    }

    shutdown(){
        this.client.shutdown()
    }

    getUser(){
        return this.client.user
    }

    isInitiated(){
        if(this.client) return true
        else return false
    }

    mapTwilioEventHandlers(adaptorHooks) {
        if (!this.client) throw new Error("chat client not initialized")
        if (!adaptorHooks) throw new Error("missing adaptor hooks")

        // TODO: throttle the handlers: lodash.throttle(handler)
        this.client.on('channelAdded', lodash.throttle(adaptorHooks.channelAdded));
        this.client.on('channelRemoved', lodash.throttle(adaptorHooks.channelRemoved));
        this.client.on('messageAdded', lodash.throttle(adaptorHooks.messageAdded));
        this.client.on('connectionError', lodash.throttle(adaptorHooks.connectionError));
        this.client.on('tokenExpired', this.updateToken)
    }

    updateToken(){
        fetchAccessToken(this.setToken)
    }

    setToken(token){
        this.client.updateToken(token)
    }

    async getChannelDescriptors(){
        if (!this.client) throw new Error("chat client not initialized")
        else {
            var descs = await this.client.getUserChannelDescriptors()
            return descs
        }
    }


    // ChatMessage
    async sendMessage(message, attributes) {
        if (!this.client) throw new Error("chat client not initialized")
        else if (!message.textMessage) throw new Error("message.textMessage is undefined")
        else {
            var channel = await this.client.getChannelBySid(message.roomId);
            await channel.sendMessage(message.textMessage, message.attributes);
            return;
        }
    }


    //AttachmentMessage
    async sendAttachment(message, attributes) {
        if (!this.client) throw new Error("chat client not initialized")
        else if (!message.attachment) throw new Error("message.attachment is undefined")
        else {
            var channel = await this.client.getChannelBySid(message.roomId);
            var attachmentAsFD = message.attachment // IMPORTANT: message.attachment must be FormData or converted to FD
            await channel.sendMessage(attachmentAsFD, message.attributes);
            return ;
        }
    }

    //CreateRoomCommand
    async createChannel(command) {
        if (!this.client) throw new Error("chat client not initialized")
        else {           
            var channel = await this.client.createChannel({
                friendlyName: command.roomName,
                isPrivate: command.isPrivateRoom,
                attributes: {
                    prospectUid: command.currentUserId,
                    ownerUid: command.oppositeUserId
                }
            })
            try{
                await channel.add(command.currentUserId);
            }catch(err){}
            try{
                await channel.add(command.oppositeUserId);
            }catch(err){}

            return command.roomName;
        }
    }

    //UpdateRoomCommand
    async updateChannelName(command) {
        if (!this.client) throw new Error("chat client not initialized")
        else {
            var channel = await this.client.getChannelBySid(command.roomId)
            await channel.updateFriendlyName(command.roomName);
            return command.roomName;
        }
    }
}


// WEBPACK FOOTER //
// ./src/third-party/twilio/chat/services/TwilioChatService.js